import FormCheckbox from './form-checkbox';

export default FormCheckbox;
